import styled from "styled-components";

import Colors from "../../../shared/colors";

export default styled.div`
  background: ${Colors.alabaster};
  padding: 140px 0px 100px 0px;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow-y: auto;

  .layout {
    max-width: 1100px;
    margin: 0 auto;

    @media screen and (max-width: 1200px) {
      max-width: 800px;
    }

    @media screen and (max-width: 850px) {
      max-width: 600px;
    }
  }

  .main-title,
  .title {
    color: ${Colors.orient};
  }

  .wrapper-contact {
    display: flex;
    width: 100%;
    flex-flow: row wrap;
    justify-content: space-between;
    span {
      margin-left: 15px;
    }

    a {
      color: ${Colors.doveGray};
      text-decoration: none;
    }
  }
  .wrapper-tehnical-issues {
    display: grid;
    span {
      margin-left: 15px;
    }

    a {
      color: ${Colors.doveGray};
      text-decoration: none;
    }
  }
  .wrapper-tehnical-report {
    display: flex;
    width: 100%;
    flex-flow: row wrap;
    justify-content: space-between;
    padding-left: 8%;
    span {
      margin-left: 15px;
    }

    a {
      color: ${Colors.doveGray};
      text-decoration: none;
    }
  }

  .green-link {
    color: ${Colors.greenHaze};
  }

  li {
    font-size: 16px;
    line-height: 19px;
    text-align: justify;
  }

  .container {
    padding-top: 55px;
  }

  .cards-div {
    text-align: center;
  }

  .brochure-container {
    display: flex;
    justify-content: center;
    gap: 100px;

    .brochure-card {
      width: 250px;
    }

    .brochuer-buttons-report-event > div {
      z-index: 1;
      position: relative;
      cursor: pointer;
    }

    .brochuer-buttons-report-event {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin-top: 20px;

      span {
        font-size: 16px;
        line-height: 19px;
        color: ${Colors.doveGray};
        text-decoration: underline;
      }

      span:hover {
        color: ${Colors.gray};
        cursor: pointer;
      }

      svg {
        margin-left: 6px;
      }
    }
  }

  .contact-us-information {
    justify-content: space-between;
  }
  .contact-us-card {
    width: 50%;
    padding: 20px;
  }
  .contact-us-card-even {
    width: 35%;
    padding: 20px 0px;
  }
  .contact-us-card-odd {
    padding: 20px 0px;
    width: 65%;
  }
`;
